import content from '../generated/content.json';

export const projects = content.projects.projects;

export function getProjectById(id) {
  return projects.find((project) => project.id === id);
}
